import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["style", "teamPanel", "team", "hosts", "routing", "weight"]

  connect() { this.refresh() }

  refresh() {
    const style = this.styleTargets.find(input => input.checked)?.value || "personal"
    const isTeam = style !== "personal"
    this.teamPanelTarget.hidden = !isTeam
    if (this.hasTeamTarget) {
      this.teamTarget.disabled = !isTeam
      this.teamTarget.required = isTeam
      this.hostsTargets.forEach(fieldset => {
        const selected = isTeam && fieldset.dataset.teamId === this.teamTarget.value
        fieldset.hidden = !selected
        fieldset.disabled = !selected
      })
    }
    this.weightTargets.forEach(container => {
      container.hidden = style !== "weighted_round_robin"
      container.querySelectorAll("input").forEach(input => { input.disabled = style !== "weighted_round_robin" })
    })
    if (this.hasRoutingTarget) {
      this.routingTarget.hidden = !isTeam || style === "collective"
      this.routingTarget.querySelectorAll("select").forEach(input => { input.disabled = !isTeam || style === "collective" })
    }
  }
}
